/**
 * message.ts
 * Sentriqs, Inc.
 *
 * Created by: Dylan Knight
 * Copyright (c) 2024 Sentriqs, Inc. All rights reserved.
 *
**/
import { DateTime } from "luxon";
import { Membership } from "./auth";

export enum ReactionContentType {
  unicode = 1,
  publicUri = 2,
  s3Uri = 3
}

export interface Reaction {
  _id: string,
  frameID?: string, // frame that transmitted this reaction
  accountID: string,
  groupID: string,
  threadID?: string | undefined,
  msgID: string, // the message to which this reaction is attached
  //msgFrameID: string, // the frameID of the message to which this reaction is attached
  created: DateTime | Date,
  contenttype: ReactionContentType,
  contentID: string,
  content: string,

  userID: string,
  firstname: string,
  lastname: string,

  // client-side only
  users?: Array<{
    reactionID: string,
    userID: string,
    firstname: string,
    lastname: string,
    membership?: Membership | null
  }>,
  loading?: boolean
}

export interface EmojiSelection {
  id: string,
  keywords: Array<string>,
  name: string,
  native: string | undefined,
  shortcodes: string,
  unified: string | undefined
}

export const CustomEmoji = [{
  id: "custom_reactions",
  name: "Custom",
  emojis: [{
    id: "glyph_ico",
    name: "Glyph Icon",
    keywords: ["glyph"],
    skins: [{ src: "/img/glyph.ico" }],
  }, {
    id: "ascii_a",
    name: "Letter A",
    keywords: ["letters"],
    skins: [{ src: "/img/emoji/ascii_a.svg" }],
  }, {
    id: "ascii_b",
    name: "Letter B",
    keywords: ["letters"],
    skins: [{ src: "/img/emoji/ascii_b.svg" }]
  }, {
    id: "ascii_c",
    name: "Letter C",
    keywords: ["letters"],
    skins: [{ src: "/img/emoji/ascii_c.svg" }]
  }, {
    id: "ascii_d",
    name: "Letter D",
    keywords: ["letters"],
    skins: [{ src: "/img/emoji/ascii_d.svg" }]
  }, {
    id: "ascii_e",
    name: "Letter E",
    keywords: ["letters"],
    skins: [{ src: "/img/emoji/ascii_e.svg" }]
  }, {
    id: "ascii_f",
    name: "Letter F",
    keywords: ["letters"],
    skins: [{ src: "/img/emoji/ascii_f.svg" }]
  }],
}];

export function emojiSelectionToContent(emoji: EmojiSelection): {content: string, contentType: ReactionContentType} {
  let contentType = ReactionContentType.publicUri;
  let content = emoji.native || "";
  switch (emoji.id) {
    case "glyph_ico":
      content = "/img/glyph.ico";
      break;
    case "ascii_a":
      content = "/img/emoji/ascii_a.svg";
      break;
    case "ascii_b":
      content = "/img/emoji/ascii_b.svg";
      break;
    case "ascii_c":
      content = "/img/emoji/ascii_c.svg";
      break;
    case "ascii_d":
      content = "/img/emoji/ascii_d.svg";
      break;
    case "ascii_e":
      content = "/img/emoji/ascii_e.svg";
      break;
    case "ascii_f":
      content = "/img/emoji/ascii_f.svg";
      break;
    default:
      contentType = ReactionContentType.unicode
      break;
  }
  return { content, contentType };
}